import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { useStore } from 'src/stores';
import { readSubscriptionTier } from 'src/stores/company/subscriptionTierRead';

/**
 * The company's plan, `{ tier, allows }`: null until it's known, when it can't be read, and while billing options are
 * off (the route answers 404 then, so nothing is asked).
 */
export const useSubscriptionTier = companyId => {
  const store = useStore();
  const enabled = !!store.account.featureFlagsStore.getIsBillingOptionsEnabled;
  // The answer remembers whose it is, so a switch shows nothing until the new company's plan arrives, never the old one.
  const _useState = useState({
      companyId: null,
      plan: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    answer = _useState2[0],
    setAnswer = _useState2[1];
  useEffect(() => {
    if (!enabled || !companyId) return undefined;
    let current = true;
    readSubscriptionTier(companyId).then(plan => {
      if (current) setAnswer({
        companyId,
        plan
      });
    });
    return () => {
      current = false;
    };
  }, [enabled, companyId]);
  return enabled && companyId && answer.companyId === companyId ? answer.plan : null;
};